export function Footer() {
  return (
    <footer className="text-neutral-grey-700 relative mt-auto pb-12 md:pb-5">
      <div className="relative mx-6 mt-20 xl:container lg:mt-24 lg:px-36 xl:px-28">
        <div className="grid xl:grid-flow-col">
          <div className="md:row-span-2 md:pr-28">
            <div className="mb-10 max-h-10 w-36">
              <svg
                className="max-h-10 !w-auto"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 462 200"
              >
                <title>Logo MAR Shopping</title>
                <g fill="none">
                  <path fill="#C20012" d="M0 0v200h462V0z"></path>
                  <path
                    fill="#FCB813"
                    d="M107.42 138.26c-12.22 3.5-23.55.53-33.84-6.58-2.27-1.56-5.6-1.64-8.2-.96-1.44.38-4.43 2.1-2.13 3.68a58.7 58.7 0 0 0 41.5 10.3c13.8-1.68 26.46-8.4 38.3-15.27 5.7-3.32-5.48-5.55-8.47-3.8-8.65 5.03-17.48 9.85-27.16 12.63zm-23.06-25.8c-.35 3-.75 6.03-1.17 9.04-.32 2.3 4.73 2.7 5.98 2.7 1.78 0 5.66-.33 5.98-2.7.4-3 .82-6.03 1.17-9.05.27-2.3-4.7-2.7-5.98-2.7-1.75 0-5.7.33-6 2.7m21.34-2.77c.63 3.44.95 7 .24 10.46-.68 3.26 11.13 4.05 11.96 0 .72-3.46.4-7.02-.24-10.46-.75-4.05-12.6-3.33-11.97 0m25.21 43.92c-10.05 2.43-20.5 3.1-30.8 3.72-15.28.9-30.8 1.27-45.9 4.04 2.15-15.46 3.1-30.98 1.95-46.6-1-13.56-3.75-26.9-7.13-40.05 5.8-.28 11.48-.8 17.1-1.63-.13 2.15-.2 4.3-.23 6.42-.02 3.8 11.94 3.8 11.97 0 .02-2.9.15-5.84.4-8.8 1.9-.45 3.8-.94 5.7-1.5a848.49 848.49 0 0 0 56.16-18.62c2.66 32.4 8.37 64.37 15.34 96.12-8.2 2.26-16.3 4.88-24.56 6.9M85.23 42.3a23.89 23.89 0 0 1 4.54-6.73c2.63-2.62 2.64-2.2 5.2.72 4.42 5.06 6.03 12.55 8.1 19l-17.72 5.83c-2.07.68-4.15 1.34-6.24 2 1.14-7.25 3.08-14.37 6.13-20.84m84.54 106.1c-7.6-34.42-13.76-69.08-16.2-104.28-.3-4.43-9.48-3.13-11.9-2.22a762.1 762.1 0 0 1-27.75 9.8c-2.42-7.8-4.84-16.62-12-20.85-6.54-3.88-15.7-3.2-21.73 1.34-6.27 4.7-8.84 13.56-10.8 20.75-1.18 4.38-2.05 8.9-2.64 13.46a78.92 78.92 0 0 1-11.97 1.68c-2.4.14-4.9.35-7.4.5l-1.7-6.1c-1.34-4.74-14.96-3.52-13.97 0 .55 1.94 1.1 3.9 1.62 5.86-1.98-.3-3.92-.78-5.8-1.48-3.06-1.14-6.8-1.37-9.85 0-2.4 1.08-2.68 3.44 0 4.45a59.23 59.23 0 0 0 17.33 3.45c3.2 12.53 5.75 25.2 6.98 38.1 1.73 17.96.23 36.02-2.57 53.8-.6 3.74 8.82 3.18 10.5 2.7 18.78-5.25 38.8-4.98 58.12-6.24 9.36-.6 18.6-1.7 27.8-3.6 10.3-2.18 20.27-5.78 30.46-8.4.93-.23 3.8-1.2 3.47-2.7"
                  ></path>
                  <path
                    fill="#FAB900"
                    d="M175.67 41.8c1.06 0 1.8-.64 1.8-1.6 0-1.04-.58-1.6-1.8-1.6h-3.3v3.2h3.3zm2.8 5.5c.02.03.03.08.04.13 0-.05 0-.1-.02-.14zm.13.37a.33.33 0 0 1-.05-.12c0 .04.02.1.04.13zm-6.23.78h-2.04V36.7h5.42c2.2 0 3.77 1.2 3.77 3.3 0 1.16-.46 2.14-1.27 2.72.67.48 1 1.3 1.06 2.43l.02.23c.03.7.03.74.06 1.02.06.62.17 1.05.3 1.2l.7.85h-2.5l-.15-.25a2.52 2.52 0 0 1-.3-1.07l-.05-.7v-.13c-.14-2.07-.42-2.66-1.65-2.62h-3.36v4.77zm2.37 5.03a10.74 10.74 0 1 1 0-21.47 10.74 10.74 0 0 1 0 21.47zm0-1.87a8.86 8.86 0 1 0-8.86-8.86c0 4.9 3.97 8.87 8.87 8.87z"
                  ></path>
                  <path
                    fill="#FEFEFE"
                    d="M217.53 75.15v35.33h-15.5V48.42h16.17l14.85 23.9 14.85-23.9h16.18v62.06H248.4v-35.6l-14.62 22.2-.86 1.33-.94-1.32zm92.93-6.55-5.87 14.33h11.72l-5.86-14.32zm-17.06 41.9h-16.3L303.72 48h13.82l26.6 62.48H327.5l-5.43-13.3H298.8l-5.43 13.3zm91.4-33.23c5.52 0 8.66-2.7 8.66-7.04v-.16c0-4.65-3.08-7.13-8.9-7.13h-11.63v14.35h11.88zm-11.87 33.23h-15.76V48.42h28.5c7.78 0 14.02 2.2 18.24 6.42 3.6 3.6 5.5 8.6 5.5 14.52 0 9.2-4.4 15.77-12.02 19.2l15 21.92h-18.54l-12.72-19h-8.2v19zm-169.88 33.1c1.35.7 3.2 1.2 4.86 1.2 1.77 0 2.62-.6 2.62-1.56 0-.88-.7-1.45-3.02-2.25-3.97-1.42-6.15-3.62-6.15-6.77 0-4.05 3.44-6.87 8.5-6.87a13 13 0 0 1 5.56 1.1l.53.25-1.42 5.08-.72-.37a8.88 8.88 0 0 0-4-.92c-1.53 0-2.32.6-2.32 1.32 0 .8.64 1.25 3.4 2.28 3.9 1.45 5.77 3.6 5.77 6.8 0 4.2-3.37 7.08-9 7.08-2.26 0-4.76-.58-6.18-1.37l-.45-.26 1.28-5.17.77.4zm30.78 6.06h-6.02v-22.03h6.03v7.95h6.34v-7.95h6.02v22.03h-6.03V141h-6.34zm29.74-10.98c0 3.83 1.72 6.25 4.36 6.25 2.6 0 4.3-2.5 4.3-6.35 0-3.7-1.7-6.25-4.3-6.25-2.64 0-4.36 2.5-4.36 6.35zm14.94-.25c0 7.07-4.27 11.56-10.82 11.56-6.27 0-10.4-4.7-10.4-11.23 0-6.68 4.4-11.5 10.74-11.5 6.4 0 10.5 4.68 10.5 11.16zm17.9-1c2.16 0 3.36-1 3.36-2.68 0-1.5-1.02-2.36-3-2.36-.5 0-.92 0-1.23.04v4.95l.88.02zm-.87 12.23h-6v-21.64l.58-.1c1.67-.28 3.8-.44 6.44-.44 3 0 5.2.58 6.73 1.8a6.64 6.64 0 0 1 2.47 5.32c0 2.23-.73 4.15-2.12 5.4-1.7 1.57-4.2 2.36-7.17 2.36-.34 0-.65 0-.92-.03v7.33zm28.02-12.24c2.15 0 3.34-1 3.34-2.67 0-1.5-1.02-2.36-3-2.36-.5 0-.92 0-1.23.04v4.95l.88.02zm-.88 12.24h-6v-21.64l.58-.1c1.66-.28 3.78-.44 6.43-.44 3 0 5.2.58 6.73 1.8a6.62 6.62 0 0 1 2.48 5.32c0 2.23-.74 4.15-2.12 5.4-1.7 1.57-4.2 2.36-7.18 2.36-.33 0-.64 0-.9-.03v7.33zm21.17 0v-22.02h6.02v22.02zm23.68-6.9v6.9h-5.65v-22.02h6.53l.2.34 4.3 7.57c.63 1.13 1.28 2.4 1.9 3.72-.07-1.5-.1-3.14-.1-4.95v-6.68h5.65v22.02h-5.98l-.2-.35-4.4-7.96a80.58 80.58 0 0 1-2.32-4.43c.05 1.8.08 3.7.08 5.86zm34.4-1.3v-5h9.05v12.05l-.46.17c-2.02.7-4.7 1.2-7.1 1.2-3.9 0-6.8-.97-8.9-2.95-2-1.94-3.1-4.82-3.1-8.03.02-7.05 5.1-11.48 12.48-11.48 2.43 0 4.67.43 6 1.04l.53.24-1.33 5.1-.73-.33c-1.2-.56-2.54-.83-4.5-.83-3.82 0-6.2 2.14-6.2 6 0 3.8 2.3 6.1 5.86 6.1.62 0 1.2-.04 1.6-.1v-3.17h-3.2z"
                  ></path>
                </g>
              </svg>
            </div>
          </div>
          <div className="text-bodym sm:col-span-3">
            <div className="pb-8 sm:pb-20">
              <div className="grid gap-8 sm:grid-cols-2 sm:gap-3 md:gap-8">
                <div>
                  <h2 className="font-title text-headings mb-2 font-bold">
                    MAR Shopping Matosinhos
                  </h2>
                  Avenida Doutor Óscar Lopes
                  <br />
                  Leça da Palmeira
                  <br />
                  4450-337 Matosinhos, Portugal
                  <br />
                  <a
                    className="hover:text-text-light underline"
                    href="tel:351229998704"
                  >
                    +351 229 998 704{' '}
                    <span className="text-xs">
                      (Chamada para rede fixa nacional)
                    </span>
                  </a>
                </div>

                <div>
                  <ul className="w-fit pt-6 first:pt-0 sm:pt-0">
                    <li>
                      <a
                        className="hover:text-text-light  mb-3 block hover:underline"
                        href="https://www.livroreclamacoes.pt/inicio"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Livro de Reclamações
                      </a>
                    </li>
                    <li>
                      <a
                        className="hover:text-text-light  mb-3 block hover:underline"
                        href="https://elogiar.livrodeelogios.com/elogiar/mar-shopping-matosinhos"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Livro de Elogios
                      </a>
                    </li>
                    <li>
                      <a
                        className="hover:text-text-light mb-3 block hover:underline"
                        href="https://www.marshopping.com/matosinhos/pt/politica-de-privacidade/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Política de Privacidade
                      </a>
                    </li>
                    <li>
                      <a
                        className="hover:text-text-light mb-3 block hover:underline"
                        href="https://www.marshopping.com/matosinhos/pt/disclaimer/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Aviso Legal
                      </a>
                    </li>
                    <li>
                      <a
                        className="hover:text-text-light mb-3 block hover:underline"
                        href="https://www.marshopping.com/matosinhos/pt/termos-e-condicoes/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Termos e condições
                      </a>
                    </li>
                    <li>
                      <a
                        className="hover:text-text-light mb-3 block hover:underline"
                        href="https://www.marshopping.com/matosinhos/pt/contatos/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Contactos
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center lg:flex-row">
          <ul className="flex flex-wrap justify-center">
            <li className="mx-1.5 lg:mx-2.5 lg:ml-0 lg:mr-5">
              <a
                href="https://api.whatsapp.com/send/?phone=351967084444&amp;text=&amp;app_absent%20=0"
                className="social-media-links-list-module--social--0a45d"
                target="_blank"
                rel="noreferrer"
                title="WhatsApp"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <title>WhatsApp</title>
                  <path
                    d="M10.012 0C4.506 0 .023 4.478.022 9.984a9.964 9.964 0 0 0 1.333 4.993L0 20l5.232-1.236a9.981 9.981 0 0 0 4.774 1.215h.004c5.505 0 9.985-4.48 9.988-9.985a9.922 9.922 0 0 0-2.922-7.066A9.923 9.923 0 0 0 10.012 0Zm-.002 2a7.95 7.95 0 0 1 5.652 2.342 7.929 7.929 0 0 1 2.336 5.65c-.002 4.404-3.584 7.986-7.99 7.986a7.999 7.999 0 0 1-3.817-.97l-.673-.367-.745.175-1.968.465.48-1.785.217-.8-.414-.72A7.98 7.98 0 0 1 2.02 9.985C2.023 5.582 5.607 2 10.01 2ZM6.477 5.375a.917.917 0 0 0-.666.313c-.23.248-.875.852-.875 2.08 0 1.228.894 2.415 1.02 2.582.123.166 1.726 2.765 4.263 3.765 2.108.831 2.536.667 2.994.625.458-.04 1.477-.602 1.685-1.185.208-.583.209-1.085.147-1.188-.062-.104-.229-.166-.479-.29-.249-.126-1.476-.728-1.705-.811-.229-.083-.396-.125-.562.125-.166.25-.643.81-.79.976-.145.167-.29.19-.54.065-.25-.126-1.054-.39-2.008-1.24-.742-.662-1.243-1.477-1.389-1.727-.145-.25-.013-.386.112-.51.112-.112.248-.291.373-.437.124-.146.167-.25.25-.416.083-.166.04-.313-.022-.438s-.547-1.357-.77-1.851c-.186-.415-.384-.425-.562-.432-.145-.006-.31-.006-.476-.006Z"
                    fill="#767571"
                  ></path>
                </svg>
              </a>
            </li>
            <li className="mx-1.5 lg:mx-2.5 lg:ml-0 lg:mr-5">
              <a
                href="https://www.facebook.com/MARShopping"
                className="social-media-links-list-module--social--0a45d"
                target="_blank"
                rel="noreferrer"
                title="Facebook"
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <title>Facebook</title>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 9.055C18 4.055 13.97 0 9 0S0 4.054 0 9.055c0 4.52 3.291 8.266 7.594 8.945v-6.328H5.309V9.055h2.285V7.06c0-2.27 1.343-3.523 3.4-3.523.984 0 2.014.177 2.014.177v2.228h-1.135c-1.118 0-1.467.698-1.467 1.414v1.699h2.496l-.399 2.617h-2.097V18C14.71 17.32 18 13.575 18 9.055Z"
                    fill="#767571"
                  ></path>
                </svg>
              </a>
            </li>
            <li className="mx-1.5 lg:mx-2.5 lg:ml-0 lg:mr-5">
              <a
                href="https://www.instagram.com/marshoppingmatosinhos/"
                className="social-media-links-list-module--social--0a45d"
                target="_blank"
                rel="noreferrer"
                title="Instagram"
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <title>Instagram</title>
                  <path
                    d="M9 4.38c.804 0 1.567.24 2.29.642a4.262 4.262 0 0 1 1.688 1.688c.402.723.643 1.486.643 2.29 0 .844-.242 1.607-.643 2.33a4.262 4.262 0 0 1-1.688 1.688A4.648 4.648 0 0 1 9 13.62c-.844 0-1.607-.2-2.33-.602a4.262 4.262 0 0 1-1.688-1.688A4.686 4.686 0 0 1 4.38 9c0-.804.201-1.567.603-2.29A4.262 4.262 0 0 1 6.67 5.022C7.393 4.621 8.156 4.38 9 4.38Zm0 7.633c.804 0 1.527-.28 2.13-.883A2.942 2.942 0 0 0 12.012 9c0-.804-.321-1.527-.883-2.13-.603-.562-1.326-.883-2.13-.883-.844 0-1.567.321-2.13.884A2.915 2.915 0 0 0 5.988 9c0 .844.28 1.567.884 2.13.562.602 1.285.883 2.129.883Zm5.906-7.834c0-.282-.12-.523-.321-.764-.241-.2-.482-.321-.764-.321-.321 0-.562.12-.763.321a1.004 1.004 0 0 0-.321.764c0 .321.08.562.321.763.2.241.442.321.763.321.282 0 .523-.08.724-.321.2-.2.321-.442.361-.763Zm3.054 1.084c0 .764.04 2.01.04 3.737 0 1.768-.04 3.013-.08 3.777a8.75 8.75 0 0 1-.322 1.969 4.76 4.76 0 0 1-1.125 1.767 4.844 4.844 0 0 1-1.727 1.085c-.563.201-1.246.322-2.01.362C11.974 18 10.729 18 9 18c-1.768 0-3.013 0-3.777-.04-.763-.04-1.406-.16-1.969-.402a4.146 4.146 0 0 1-1.767-1.045 4.675 4.675 0 0 1-1.085-1.768C.2 14.184.08 13.54.04 12.777 0 12.013 0 10.767 0 9c0-1.728 0-2.973.04-3.737C.08 4.5.2 3.817.402 3.254a4.844 4.844 0 0 1 1.085-1.727A4.76 4.76 0 0 1 3.254.402 8.754 8.754 0 0 1 5.224.08C5.986.04 7.231 0 9 0c1.728 0 2.973.04 3.737.08a9.14 9.14 0 0 1 2.008.322 4.944 4.944 0 0 1 1.728 1.125 4.944 4.944 0 0 1 1.125 1.727c.16.563.282 1.246.362 2.01Zm-1.929 9.04c.161-.441.241-1.165.322-2.17 0-.562.04-1.405.04-2.49V8.357c0-1.085-.04-1.928-.04-2.49-.08-1.005-.161-1.729-.322-2.17a3.046 3.046 0 0 0-1.727-1.728c-.442-.161-1.166-.241-2.17-.322-.603 0-1.447-.04-2.491-.04H8.357c-1.085 0-1.928.04-2.49.04-1.005.08-1.729.161-2.17.322-.844.321-1.407.924-1.728 1.727-.161.442-.282 1.166-.322 2.17-.04.603-.04 1.447-.04 2.491v1.286c0 1.085 0 1.928.04 2.49.04 1.005.161 1.729.322 2.17.321.844.924 1.407 1.727 1.728.442.161 1.166.282 2.17.322.563.04 1.406.04 2.491.04h1.286c1.085 0 1.928 0 2.49-.04 1.005-.04 1.729-.161 2.17-.322a3.046 3.046 0 0 0 1.728-1.727Z"
                    fill="#767571"
                  ></path>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="pointer-events-none absolute bottom-0 left-0 -z-50 h-52 w-full sm:h-[31rem]">
        <svg
          className="absolute bottom-0 left-0 w-44 fill-portal-primary lg:w-[26rem]"
          viewBox="0 0 374.8 398.7"
          aria-hidden="true"
        >
          <path d="M357.2 354.9c-39-100-80.6-195.4-159.5-264.1C145 45 76.6 14.2 0 .5v82.3c56.3 12.1 106 35.6 144.6 69.1 65 56.5 102 142.2 137.3 232.7 1.8 4.7 3.7 9.4 5.5 14.1h87.3c-6.1-14.4-11.8-29.2-17.5-43.8z"></path>
        </svg>
        <svg
          className="absolute bottom-0 right-0 w-52 fill-portal-primary  lg:w-[31rem]"
          viewBox="0 0 493.47 212"
          aria-hidden="true"
        >
          <path d="M151.83 212c81.32-46.19 171.57-90.97 232.45-102.16-19.15 30.07-60.77 75.78-85.36 102.16h104.59c59.33-69.38 81.8-113.98 61.89-150.74-14.55-26.87-45.62-36.41-92.36-28.32C269.1 50.91 100.43 149.2.58 212h151.25Z"></path>
        </svg>
      </div>
    </footer>
  );
}
